// extracted by mini-css-extract-plugin
export default {"commentContainer":"ImportHomework_commentContainer__8ALfT","commentTitle":"ImportHomework_commentTitle__e8AXv"};